<div>
    <p *ngFor="let message of messages">
        {{message}}
    </p>
</div>